var React = require('react');

function IconExport (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M680.3 127.9l238.2 216.2c4.4 4 4.4 10.8 0 14.8L680.3 575.1V439.9c-69.7 0-278.8 0-371.7 209.1v-23.2c0-92.9 92.9-391.5 371.7-371.7V127.9zM108 306.6h184.9v70.8H176.2v439.1h670.3v-191h77.7v259.1c0 5.3-4.2 9.6-9.5 9.6H108c-5.3 0-9.6-4.2-9.6-9.6V316.2c0-5.3 4.3-9.6 9.6-9.6z"}));
}

IconExport.displayName = "IconExport";

IconExport.defaultProps = {"viewBox":"0 0 1024 1024"};

module.exports = IconExport;

IconExport.default = IconExport;
